var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIHealthCareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 90",
    style: {
      enableBackground: "new 0 0 330 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0777B9;}\n\t.st1{fill:#62C08A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 38.9,
    className: "st0",
    width: 9.2,
    height: 25.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,49.1H25.8v15.6h-9.2v-38h9.2v14.9h14.4V26.8h9.2v38h-9.2C40.2,64.8,40.2,49.1,40.2,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.5,65.2c-8.9,0-15.2-5.9-15.2-15.5s6.3-15.6,15.2-15.6c8.8,0,15,5.8,15,15c0,0.9-0.1,1.8-0.2,2.7H63.5 c0.3,3.9,2.8,5.8,5.7,5.8c1.6,0,2.8-0.5,3.6-1.3c1.3-1.2,3-1.6,4.7-1.6h6.3C82.4,60.6,77.1,65.2,69.5,65.2z M63.5,46.7h11.6 c0-3.3-2.6-5.2-5.7-5.2C66.4,41.5,64.1,43.4,63.5,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.9,34.1c4.5,0,7.7,2.1,9.3,4.7l0,0c0-2.4,1.9-4.3,4.3-4.3h5v30.2h-5c-2.4,0-4.3-1.9-4.3-4.3l0,0 c-1.7,2.7-4.9,4.7-9.4,4.7c-7.4,0-13.2-6.1-13.2-15.6C87.6,40.1,93.5,34.1,100.9,34.1z M103.6,42.2c-3.5,0-6.6,2.6-6.6,7.4 s3.1,7.5,6.6,7.5s6.6-2.6,6.6-7.5S107.1,42.2,103.6,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.1,24.7L126.1,24.7c5.1,0,9.2,4.1,9.2,9.2v30.8h-3.1c-3.4,0-6.2-2.8-6.2-6.2L126.1,24.7L126.1,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.6,46.2h9.2v8.1c0,1.8,0.8,2.5,2.8,2.5h3.3v7.8h-4.7c-6.3,0-10.7-2.6-10.7-10.5L143.6,46.2L143.6,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.6,34.2c-4.2,0-7.5,1.8-9.3,4.4V24.7H164v40h9.2V48.3c0-4.1,2.3-6.4,5.8-6.4s5.8,2.3,5.8,6.4v16.4h9.2 V47.1C194.1,39,189.5,34.2,182.6,34.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.5,30.4v9.2h-5.7v5.7h-9.2v-9.5c0-3,2.4-5.5,5.5-5.5L158.5,30.4L158.5,30.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.9,39.6v-9.2h5.7v-5.7h9.2v9.5c0,3-2.4,5.5-5.5,5.5L137.9,39.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,46.9c-0.2,0-0.5,0-0.7,0c-3.3,0.2-6.3,1.9-8.2,4.7c0,0.1-0.1,0.1-0.2,0.2l0,0l0,0c-0.5,0.8-1.2,1.5-2,2 c-0.2,0.2-0.4,0.3-0.6,0.5c0,0-0.1,0.1-0.2,0.1l0,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.7,0.3c0,0-0.1,0-0.2,0.1 c-0.2,0.1-0.5,0.2-0.8,0.3c0,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0-0.5,0.1-0.7,0.1c-0.5,0.1-1,0.1-1.5,0.1 c-0.2,0-0.3,0-0.5,0h-0.1c-0.6,0-1.2-0.1-1.8-0.3c-0.9-0.2-1.8-0.6-2.6-1.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.6-0.4-1.2-0.9-1.7-1.5 c-0.2-0.2-0.3-0.3-0.4-0.5c-0.7-0.9-1.2-1.9-1.6-2.9c-0.1-0.3-0.2-0.5-0.2-0.8c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.2,0-0.3 c0-0.2-0.1-0.4-0.1-0.7c-0.1-0.5-0.1-1.1,0-1.6c0-0.7,0.1-1.3,0.3-1.9c0.2-0.7,0.4-1.4,0.8-2c0.2-0.5,0.5-0.9,0.8-1.3l0,0 c0.4-0.5,0.8-1,1.2-1.4c1.8-1.7,4.1-2.7,6.7-2.7c0.2,0,0.3,0,0.5,0c0.8,0,1.5,0.2,2.2,0.4c0.2,0,0.4,0.1,0.7,0.2 c0.1,0,0.2,0.1,0.3,0.1c0.4,0.2,0.9,0.4,1.3,0.6c0.5,0.3,0.9,0.6,1.3,0.9l0,0c0.2,0.1,0.3,0.3,0.5,0.4c0.2,0.1,0.3,0.3,0.4,0.4l0,0 c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1,0.1,0.1c2,2.5,5,3.9,8.2,4h0.3c1.1,0,2.2-0.2,3.2-0.5 c-1.1-9.8-9.5-17.4-19.6-17.4c-2.3,0-4.5,0.4-6.5,1.1c-0.1,0-0.2,0-0.3,0.1C205,29.6,200,35.7,199,43c-0.1,0.5-0.1,1-0.1,1.5 c0,0.4,0,0.7,0,1.1s0,0.8,0,1.1c0.4,7,4.5,13,10.3,16.2c0.1,0,0.2,0.1,0.3,0.2c2.7,1.4,5.8,2.2,9.1,2.2c10.4,0,19-8.1,19.7-18.3 C237.6,47,236.7,46.9,235.9,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.5,34.6c-2.2,0-4,1.8-4,4v0.3c-1.6-2.7-4.8-4.7-9.3-4.7c-5.1,0-9.5,2.9-11.8,7.8c-0.8,1.7-1.3,3.6-1.5,5.8 c-0.1,0.6-0.1,1.3-0.1,1.9c0,9.5,5.9,15.6,13.3,15.6c2.2,0,4.1-0.5,5.7-1.4c1.6-0.9,2.8-2,3.6-3.4c0,2.4,1.9,4.3,4.3,4.3h5V34.6 H266.5z M249.3,49.6c0-4.8,3.1-7.4,6.6-7.4c3.5,0,6.6,2.7,6.6,7.5s-3.1,7.5-6.6,7.5C252.4,57.1,249.3,54.4,249.3,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.7,64.7h-9.2V34.6h9.2v5c2.1-3.2,5.4-5.4,9.5-5.4V44h-2.5c-4.4,0-6.9,1.5-6.9,6.7v14H287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315,65.2c-8.9,0-15.2-5.9-15.2-15.5S306,34.1,315,34.1c8.8,0,15,5.8,15,15c0,0.9-0.1,1.8-0.2,2.7h-20.9 c0.3,3.9,2.8,5.8,5.7,5.8c1.6,0,2.8-0.5,3.6-1.3c1.3-1.2,3-1.6,4.7-1.6h6.3C327.8,60.6,322.5,65.2,315,65.2z M309,46.7h11.6 c0-3.3-2.6-5.2-5.7-5.2C311.8,41.5,309.5,43.4,309,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,36.8H4.5c-2.5,0-4.5-2-4.5-4.5v-5.5h5.5c2.5,0,4.5,2,4.5,4.5V36.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHealthCareLogo);
export default __webpack_public_path__ + "static/media/iHealthCare_logo.41c5cc3672b3d562a8bab67371149935.svg";
export { ForwardRef as ReactComponent };